<template>
  <div class="apply_box">
    <div class="header">
      <div class="left">
        <p class="title">应还金额(含滞纳金)</p>
        <p class="val">{{loanInfo.allMoney}}</p>
        <p class="compayn">单位：元</p>
      </div>
      <div class="right">
        <p class="title">应还日期</p>
        <p class="val">{{loanInfo.repayTime}}</p>
        <p class="compayn">请及时还款</p>
      </div>
    </div>
    <div class="pro_detail">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> 贷款详情 </h1>
      </div>
      <div class="pro_item">
        <p>借款金额(元)</p>
        <p>{{loanInfo.loanMoney}}</p>
      </div>
      <div class="pro_item">
        <p>借款期限(元)</p>
        <p>{{loanInfo.limit}}</p>
      </div>
      <div class="pro_item">
        <p>月利率</p>
        <p>{{loanInfo.rate}}</p>
      </div>
    </div>
    <div class="bg"></div>
    <div class="pro_detail">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> 还款计划 </h1><span class="look"
              @click="toPage('/afterLoan1/limitPage')">点击查看></span>
      </div>
    </div>
    <div class="bg"></div>
    <div class="pro_detail">
      <div class="pro_item"
           v-if="showCard">
        <h1 class="h1"><span class="line"></span> 还款银行卡</h1>
      </div>
      <div class="card_box"
           v-if="showCard">
        <div class="pro_item1">
          <img class="bank_icon left"
               src=""
               alt="">
          <p class="bank_name left">中国工商银行</p>
          <span class="card_num left">&nbsp;&nbsp;储蓄卡 | 尾号8511</span>
          <!-- <span class="replace_btn right">更换</span> -->
        </div>
      </div>
      <div class="info_box">
        注：还款时需保证银行卡余额充足；银行卡需开通银联在线支付
      </div>
    </div>
    <div class="btn_box">
      <div class="loan_btn"
           @click="toPage('/afterLoan1/success')">还款</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      orderId: '',
      page: '',
      loanInfo: {
        loanMoney: '3000.00',
        allMoney: '3100',
        repayTime: '2023.03.15',
        limit: '3期',
        rate: '1%'
      },
      showCard: false
    }
  },
  mounted () {
    this.page = this.$route.query.page;
    this.util.title('还款详情');
    if (this.page == 1) {
      this.showCard = false;
      this.loanInfo = {
        loanMoney: '3000.00',
        allMoney: '3090',
        repayTime: '2023.03.20',
        limit: '3期',
      }
    } else if (this.page == 2) {
      this.showCard = true;
      this.loanInfo = {
        loanMoney: '5000.00',
        allMoney: '5200',
        repayTime: '2023.03.21',
        limit: '3期',
      }
    } else if (this.page == 3) {
      this.showCard = true;
      this.loanInfo = {
        loanMoney: '9000.00',
        allMoney: '9300',
        repayTime: '2023.03.10',
        limit: '6期',
      }
    }
  },
  methods: {
    toPage (pageUrl, status) {
      this.$router.push({
        path: pageUrl,
        query: {
          page: this.page
        }
      })

    },
  }
}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.85rem 0.41rem 0.3rem 0.41rem;
  /* margin-bottom: 0.1rem; */
  height: 2.3rem;
  width: 100%;
  background: url('../../assets/img/afterLoan/pay_bg.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  color: #fff;
  font-size: 0.12rem;
}
.header .val {
  font-size: 0.3rem;
}
.header .left,
.header .right {
  text-align: center;
}
.pro_detail {
  background: #ffffff;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.card_num {
  color: #999;
  font-size: 0.12rem;
}
.bank_name {
  coor: #333;
  font-size: 0.14rem;
  margin-right: 0.1rem;
}
.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
}
.bank_icon {
  display: inline-block;
  width: 0.32rem;
  height: 0.2rem;
  margin-right: 0.1rem;
  background: url('../../assets/img/afterLoan/bank_icon.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle {
  position: relative;
  top: 0.02rem;
  margin-right: 0.1rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/checked.png') no-repeat top center;
  background-size: 100% 100%;
}
.bank_btn {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/add_btn.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  margin-right: 0.1rem;
  position: relative;
  top: 0.02rem;
}
.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}
.continue_loan {
  background: #fff;
  border: 1px solid #486cff;
  color: #486cff;
  margin-bottom: 0.15rem;
}
.btn_box {
  margin-top: 0.3rem;
}
</style>